var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 54,
    r: 16,
    fill: "#C75E5A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 54,
    r: 14,
    fill: "#F9907B",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 54,
    r: 12,
    fill: "#FAC1B5",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 38C60 24 36 24 24 38",
    stroke: "#C75E5A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "5 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34L24 38L20 34",
    stroke: "#C75E5A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNBack);
export default __webpack_public_path__ + "static/media/NBack.e5e58e11e08ce0c90d45023e6ea5f14f.svg";
export { ForwardRef as ReactComponent };